import { useRouter } from 'next/router'
import useGlobalStore from '@/store/useGlobalStore'

const useParseLinkUrlWithLocale = () => {
  const {
    app: { alpha3, language },
  } = useGlobalStore()

  const { asPath } = useRouter()

  const parseLinkUrlWithLocale = ({
    url,
    withQueryString = false,
  }: {
    url: string
    withQueryString?: boolean
  }) => {
    const queryString = withQueryString ? asPath.split('?')[1] ?? '' : ''
    // eslint-disable-next-line sonarjs/no-nested-template-literals
    return `/${alpha3}/${language}${url}${queryString ? `?${queryString}` : ''}`
  }

  return { parseLinkUrlWithLocale }
}

export default useParseLinkUrlWithLocale
